module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fQ125r/tc-custom/9781626818088.jpg?1705894960362",
      "alt": "This image is the cover for the book Glimpse of Tiger"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Glimpse of Tiger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The international bestselling author of "), _c('i', [_vm._v("Summer of ’42")]), _vm._v(" delivers a darkly comic love story. “A strange and moving tale with a shocker climax” ("), _c('i', [_vm._v("The Boston Globe")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Tiger is a nineteen-year-old runaway who comes to the big city to start anew. There she meets Luther, a quirky con artist with charm to burn. Together they pull small scams and petty crimes on the populace of New York in the 1970s, making their money and falling in love. But a con artist is a con artist seven days a week, and soon Tiger finds herself wondering if Luther will ever be able to settle down and start building a life with her."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This mesmerizing, surprising novel explores two unforgettable people as they live and love in Manhattan—and enchants readers with a romance impossible to forget."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “An utterly different contemporary love story.” —"), _c('i', [_vm._v("Publishers Weekly")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “This hustles and hypes in a very attractive fashion.” —"), _c('i', [_vm._v("Kirkus Reviews")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Herman Raucher\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0